import Header from "@components/Header/Header";
import { SKY_BLUE } from "@styles/colors";
import { useNavigate, useLocation } from "react-router";
import { Container, ContentContainer, Divider, ListContainer, PageWrapper, Title } from "./TopUpMethod.styles";
import AlertBox from "@components/AlertBox/AlertBox";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import useKYCDetail from "@hooks/useKYCDetail";
import LoadingModal from "@components/LoadingModal/LoadingModal";
import { setHeaderColor } from "@lib/telegram";
import ListItem from "@components/ListItem/ListItem";

const CryptoIcon = () => {
    return (
        <svg width="16" height="16" viewBox="0 0 14 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M0 10V13C0 14.6569 3.13401 16 7 16C10.866 16 14 14.6569 14 13V10C14 11.6569 10.866 13 7 13C3.13401 13 0 11.6569 0 10Z" fill="white" />
            <path d="M0 5V8C0 9.65685 3.13401 11 7 11C10.866 11 14 9.65685 14 8V5C14 6.65685 10.866 8 7 8C3.13401 8 0 6.65685 0 5Z" fill="white" />
            <path d="M14 3C14 4.65685 10.866 6 7 6C3.13401 6 0 4.65685 0 3C0 1.34315 3.13401 0 7 0C10.866 0 14 1.34315 14 3Z" fill="white" />
        </svg>
    )
}

const BankIcon = () => {
    return (
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fillRule="evenodd" clipRule="evenodd" d="M8.49631 0.631757C8.18888 0.456081 7.81146 0.456081 7.50403 0.631757L0.504032 4.63176C0.0245148 4.90577 -0.142082 5.51662 0.131928 5.99614C0.316311 6.31881 0.65322 6.49979 1 6.50017V13.5C0.447715 13.5 0 13.9477 0 14.5C0 15.0523 0.447715 15.5 1 15.5H15C15.5523 15.5 16 15.0523 16 14.5C16 13.9477 15.5523 13.5 15 13.5V6.50017C15.3469 6.49991 15.684 6.31892 15.8684 5.99614C16.1424 5.51662 15.9758 4.90577 15.4963 4.63176L8.49631 0.631757ZM4 7.5C3.44772 7.5 3 7.94772 3 8.5V11.5C3 12.0523 3.44772 12.5 4 12.5C4.55228 12.5 5 12.0523 5 11.5V8.5C5 7.94772 4.55228 7.5 4 7.5ZM7 8.5C7 7.94772 7.44772 7.5 8 7.5C8.55229 7.5 9 7.94772 9 8.5V11.5C9 12.0523 8.55229 12.5 8 12.5C7.44772 12.5 7 12.0523 7 11.5V8.5ZM12 7.5C11.4477 7.5 11 7.94772 11 8.5V11.5C11 12.0523 11.4477 12.5 12 12.5C12.5523 12.5 13 12.0523 13 11.5V8.5C13 7.94772 12.5523 7.5 12 7.5Z" fill="white" />
        </svg>
    )
}

const TopUpMethod = () => {
    const { data: kycDetail, isLoading } = useKYCDetail();
    const location = useLocation();
    const state = location.state as { returnTo?: string; previousState?: any } | undefined;

    useEffect(() => {
        setHeaderColor(SKY_BLUE)
    }, [])
    const { t } = useTranslation();
    const navigate = useNavigate();

    const handleBackClick = () => {
        if (state?.returnTo === 'payment-summary' && state?.previousState) {
            // Navigate back to payment summary without the returnTo flag to prevent infinite loop
            navigate('/payment-summary', {
                state: {
                    ...state.previousState,
                    fromTopUpMethod: true
                }
            });
        } else {
            navigate('/home');
        }
    };

    return (
        <PageWrapper>
            {isLoading && <LoadingModal visible={isLoading} />}
            <Container>
                <Header title={t('topUpMethod.header')} showBackButton onBackClick={handleBackClick} $transparent />
                <Title>{t('topUpMethod.title')}</Title>
            </Container>
            <ContentContainer>
                <ListContainer>
                    <ListItem title={t('topUpMethod.methods.cryptocurrency.title')} description={t('topUpMethod.methods.cryptocurrency.description')} icon={<CryptoIcon />} onClick={() => navigate('/top-up-crypto-select-asset')} />
                    <Divider />
                    <ListItem
                        title={t('topUpMethod.methods.bankTransfer.title')}
                        description={t('topUpMethod.methods.bankTransfer.description')}
                        icon={<BankIcon />}
                        onClick={() => navigate('/top-up-bank-select')}
                        disabled={
                            !(
                                kycDetail?.kyc_level === 'kyc-level-1' &&
                                kycDetail?.review_status === 'APPROVED'
                            ) && !isLoading
                        }
                    />
                    {!(
                        kycDetail?.kyc_level === 'kyc-level-1' &&
                        kycDetail?.review_status === 'APPROVED'
                    ) && !isLoading && <AlertBox alertText={t('topUpMethod.kycAlert.message')} onClick={() => navigate('/account-upgrade')} actionText={t('topUpMethod.kycAlert.actionText')} fontSize={14} />}
                </ListContainer>
            </ContentContainer>
        </PageWrapper>
    );
};

export default TopUpMethod;